import React from 'react';
import { Helmet } from 'react-helmet';
import BookingSection from '../components/BookingSection';
import { MapPin, Globe } from 'lucide-react';

const TransfertBruxellesAmsterdam = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Helmet>
        <title>Transfert Bruxelles Amsterdam | Chauffeur Privé Belgique Pays-Bas</title>
        <meta name="description" content="Transfert privé Bruxelles Amsterdam. Chauffeur longue distance, 2h, prix fixe. Service porte-à-porte international." />
        <meta name="keywords" content="transfert bruxelles amsterdam, taxi bruxelles amsterdam, chauffeur privé amsterdam, bruxelles pays-bas" />
        <link rel="canonical" href="https://www.luxurytransferservices.be/transfert-bruxelles-amsterdam" />
      </Helmet>

      <section className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <Globe className="w-16 h-16 text-gold mx-auto mb-6" />
            <h1 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-gold via-yellow-300 to-gold bg-clip-text text-transparent">
              Bruxelles ↔ Amsterdam
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Transfert privé international Belgique - Pays-Bas. 2h, service premium.
            </p>
          </div>
        </div>
      </section>

      <section id="booking" className="py-12 bg-gray-900">
        <div className="container mx-auto px-4">
          <BookingSection defaultPickup="Bruxelles" defaultDropoff="Amsterdam" />
        </div>
      </section>

      <section className="py-16 bg-gray-900">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gold mb-6">Transfert International Bruxelles - Amsterdam</h2>
          <p className="text-gray-300 mb-4">
            <strong>Service de transfert longue distance</strong> Bruxelles → Amsterdam (Pays-Bas). Trajet de 2h en tout confort. 
            Idéal pour déplacements professionnels, tourisme, ou correspondances aéroport Schiphol. Prix fixe tout compris.
          </p>
          <ul className="text-gray-300 space-y-2 mt-6">
            <li>✅ Trajet direct sans arrêt</li>
            <li>✅ Wifi à bord</li>
            <li>✅ Boissons & snacks</li>
            <li>✅ Chauffeur multilingue</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default TransfertBruxellesAmsterdam;